if (!customElements.get('scroll-arrows')) {
  class ScrollArrows extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroll-arrows-track]');
      this.prev = this.querySelector('[data-scroll-arrows-prev]');
      this.next = this.querySelector('[data-scroll-arrows-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.prev.addEventListener('click', () => this.scrollStep(-1), { signal });
      this.next.addEventListener('click', () => this.scrollStep(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      Array.from(this.track.children).forEach((child) => this.resizeObserver.observe(child));

      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }

    scrollStep(direction) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * this.track.clientWidth * 0.8,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      this.toggleAttribute('overflowing', maxScroll > 1);
      this.prev.disabled = scrollLeft <= 1;
      this.next.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define('scroll-arrows', ScrollArrows);
}
